module.exports = __webpack_public_path__ + "static/media/maciejdzik.4c2eba29.JPG";